import { BackgroundImage } from '../videoEffectTypes';

interface CacheEntry {
  data: BackgroundImage[];
  fetchedAt: number;
}

const CACHE_TTL_MS = 5 * 60 * 1000;

let cache: CacheEntry | null = null;

function prewarmImages(backgrounds: BackgroundImage[]): void {
  backgrounds.forEach(({ url }) => {
    if (!url) return;
    const img = new Image();
    img.src = url;
  });
}

export const backgroundCache = {
  get(): BackgroundImage[] | null {
    if (!cache) return null;
    return cache.data;
  },

  isStale(): boolean {
    if (!cache) return true;
    return Date.now() - cache.fetchedAt > CACHE_TTL_MS;
  },

  set(data: BackgroundImage[]): void {
    cache = { data, fetchedAt: Date.now() };
    prewarmImages(data?.filter(({ url }) => !url) ?? []);
  },

  clear(): void {
    cache = null;
  },
};
